import React, { useEffect, useRef, useState } from "react";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../component/ui/dropdown-menu";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Field, Form } from "react-final-form";

import {
  composeValidators,
  renderField,
  required,
} from "../../helpers/form-validations";
import { meta } from "eslint-plugin-prettier";
import { IoIosArrowBack, IoIosArrowDown, IoMdAdd } from "react-icons/io";
import { Label } from "../ui/label";
import {
  addEmailTemplate,
  EditEmailTemplate,
  getAllEmailTemplateDetails,
  getEmailTemplatesDropdown,
} from "../../utils/util";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import EmailEditorForEmailTemplate from "../ui/emailEditor";
import { template } from "lodash";
import { loaderSet } from "../../context/actions/loaderAction";
import { alertDanger, alertSuccess } from "../../context/actions/toastAction";
import Loader from "../loader";
import { setAllEmailTemplateDetails } from "../../context/actions/allEmailTemplateDetailsAction";

const AddEmailTemplate = ({back,getAllEmailTemplate,forWhichUserType}) => {
  const [searchParams] = useSearchParams();
  const templateId = searchParams.get("template_id");
  const actionType = searchParams.get("action_type");
  const dispatch=useDispatch()
  const emailTemplateInfo = useSelector((state) => state.emailTemplateInfo);
 const [emailTemplateBodyInHtmlFormat,setEmailTemplateBodyInHtmlFormat]=useState()
 const navigate=useNavigate()
 const [isLoading,setIsLoading]=useState(false)
  useEffect(() => {
    if (emailTemplateInfo) {
    }
  }, []);

  const emailEditorRef = useRef(null);
  const userInfo=useSelector(state=>state.user)



  const handleSetEmailTemplateBody=(html)=>{
    setEmailTemplateBodyInHtmlFormat(html)
  }

  useEffect(()=>{
    if(emailTemplateInfo){
      console.log("Email Template Info",emailTemplateInfo)
      console.log("email JSON design",JSON.parse(emailTemplateInfo.json_design))
    }
  },[emailTemplateInfo])


    const getAllEmailTemplateDetailsForDropdown=async()=>{
      try {
        const response =await getEmailTemplatesDropdown()
        console.log("response for gett all Email Template dropdown from admin index.js file ",response.data)
        if(response){
          dispatch(setAllEmailTemplateDetails(response.data));
        }
      } catch (error) {
        console.log("Error in get all Email Temaplate dropdown ",error)
      }
    }

  const onSubmit = async (values) => {
    setIsLoading(true)
    try {
      const body = await emailEditorRef.current.exportHtml(); // Call the export function
      setEmailTemplateBodyInHtmlFormat(body); // Set the HTML in state



       
      const payload = {
        template_id:actionType==="Edit"?templateId:null,
        user_id: emailTemplateInfo &&  emailTemplateInfo.user_id ?  emailTemplateInfo.user_id : userInfo && userInfo.user_id,
        template_name: values && values.emailTemplateName ?values.emailTemplateName:  emailTemplateInfo && emailTemplateInfo.template_name ,
        body: body && body.html ? body.html: emailTemplateInfo && emailTemplateInfo.body  , // Use the exported HTML
        json_design: body && body.design ? JSON.stringify(body.design):  emailTemplateInfo && emailTemplateInfo.body,
        subject: values && values.subject  ?values.subject: emailTemplateInfo && emailTemplateInfo.subject ,
      };

      let response;
      if (actionType === "Edit") {
        response = await EditEmailTemplate(payload);
        if(response.code===200){
          dispatch(alertSuccess("Email Template Updated  Successfully"))
          getAllEmailTemplate()
          if(forWhichUserType==="employee"){
            navigate("/employee")
          }
          if(forWhichUserType==="admin"){
            navigate("/admin")
          }
          // dispatch(loaderSet(false))
          getAllEmailTemplateDetailsForDropdown()
          setIsLoading(false)
        }
        else{
          dispatch(alertDanger(response?.message))
          console.log("Payload for create/edit email template",response);
          setIsLoading(false)
        }
      } else {
        console.log("payload",payload,body)
        response = await addEmailTemplate(payload);
        if(response.code===200){
          dispatch(alertSuccess("Email Template Created Successfully"))
          getAllEmailTemplate()
          getAllEmailTemplateDetailsForDropdown()
          back()
          // dispatch(loaderSet(false))
          setIsLoading(false)
        }
        else{
          dispatch(alertDanger(response?.message))
          setIsLoading(false)
        }
      }

      console.log("Response for create email template", response);
    } catch (error) {
      console.error("Error in email template function", error);
      setIsLoading(false)
    }
    // finally {
    //   setTimeout(() => dispatch(loaderSet(false)), 1000); // Adds a slight delay
    // }
  };

  

  return (
    <>

{
        isLoading && <Loader/>
      }

      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <div className="w-full flex flex-col p-6  bg-[#FFFFFF] rounded-md gap-16">
        
              <div className="w-full ">
                <div className="flex w-full justify-between items-center gap-4 flex-col ">
                <Button
                type="button"
        variant="outline"
        size="sm"
        className=" h-10  gap-1 text-sm w-max self-start  "
        onClick={()=>{
          if(forWhichUserType==="employee"){
            navigate("/employee")
          }
          if(forWhichUserType==="admin"){
            navigate("/admin")
          }
          back()
          
        }
        } 
      >
        <IoIosArrowBack />
        Back
      </Button> 
                  {/* Ticker name Input field */}
                  <div className="gap-2 w-[100%] flex flex-col">
                    <Label
                      className="text-start text-[#0D215C] font-bold text-lg "
                      htmlFor="emailTemplateName"
                    >
                      Email Template Name
                    </Label>
                    <Field
                      id="emailTemplateName"
                      type="text"
                      name="emailTemplateName"
                      placeholder="Email Template Name"
                      actionType={actionType}
                      info={
                        emailTemplateInfo && emailTemplateInfo?.template_name
                      }
                      // validate={composeValidators(required)}
                      component={renderField} // Correct usage of renderField
                      className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                    />
                    {/* Reserve space for the error message */}
                    {meta.touched && meta.error && (
                      <p className="text-red-500 text-sm text-left my-[2px]">
                        &nbsp;{meta.error}
                      </p>
                    )}
                  </div>

                  <div className="gap-2 flex flex-col w-[100%]">
                    <Label
                      className="text-start text-[#0D215C] font-bold text-lg"
                      htmlFor="subject"
                    >
                      Subject
                    </Label>
                    <Field
                      id="subject"
                      type="text"
                      name="subject"
                      placeholder="Subject"
                      actionType={actionType}
                      info={emailTemplateInfo && emailTemplateInfo?.subject}
                      // validate={composeValidators(required)}
                      component={renderField} // Correct usage of renderField
                      className="bg-muted/40 h-9 w-full rounded-base text-base border-[#3a5dd1] manrope-fontCss"
                    />
                    {/* Reserve space for the error message */}
                    {meta.touched && meta.error && (
                      <p className="text-red-500 text-sm text-left my-[2px]">
                        &nbsp;{meta.error}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-full bg-muted/40 h-2 "></div>
              <div className="w-full flex md:flex-row p-6 flex-col  bg-[#FFFFFF] rounded-md gap-16">
                {/* <div className="border-[#3a5dd1] md:w-[49%] sm:w-full ">
                  <Field
                    id="emailTemplateBody"
                    type="textarea"
                    name="emailTemplateBody"
                    placeholder="Email Template"
                    info={emailTemplateInfo && emailTemplateInfo?.body}
                    validate={composeValidators(required)}
                    component={renderField}
                    className="bg-muted/40 min-h-96 w-full rounded-md text-base border p-2 border-[#3a5dd1] manrope-fontCss placeholder:text-center placeholder:p-40 focus:outline-none"
                  />

                
                </div> */}

                {/* Right Section  */}

                <div className="  md:w-full max-h-96 w-full flex justify-between ">
                  <div className="flex   w-full  justify-start items-center gap-5 ">
                    {/* Ticker name Input field */}
                    <div className="flex w-full gap-2">
                      <div className="gap-2  w-[100%]  border-[#3a5dd1] flex items-center justify-center">
                        <Label
                          className="text-center text-[#0D215C] w-[100%] rounded-lg px-10 py-2  font-bold text-lg border border-[#3a5dd1]  "
                          htmlFor=""
                        >
                          {"{{Investor Name}}"}
                        </Label>
                      </div>

                      {/* Dropdown Menu */}
                      {/* <div className="flex items-center    w-[79%]  gap-2">
                        <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                        <Button variant="outline" size="lg" className="h-10 gap-1 w-full text-md border-[#3a5dd1] flex justify-between">
                        <span className="sr-only sm:not-sr-only">Name</span>

                        <span className="ml-1 text-[#0D215C]"><IoIosArrowDown /></span>
                        </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent  className={"w-[var(--radix-dropdown-menu-trigger-width)]"} >
                        <DropdownMenuLabel>Investor Name</DropdownMenuLabel>
                        <DropdownMenuSeparator />
                        <DropdownMenuCheckboxItem checked>Option 1</DropdownMenuCheckboxItem>
                        <DropdownMenuCheckboxItem>Option 2</DropdownMenuCheckboxItem>
                        <DropdownMenuCheckboxItem>Option 3</DropdownMenuCheckboxItem>
                        </DropdownMenuContent>
                        </DropdownMenu>
                        </div> */}
                    </div>
                    <div className="flex w-full gap-2">
                      <div className="gap-2  w-[100%]  border-[#3a5dd1] flex items-center justify-center">
                        <Label
                          className="text-center text-[#0D215C] w-[100%] rounded-lg px-10 py-2  font-bold text-lg border border-[#3a5dd1]  "
                          htmlFor=""
                        >
                          {"{{Date}}"}
                        </Label>
                      </div>

                      {/* Dropdown Menu */}
                    </div>
                    <div className="flex w-full gap-2">
                      <div className="gap-2  w-[100%]  border-[#3a5dd1] flex items-center justify-center">
                        <Label
                          className="text-center text-[#0D215C] w-[100%] rounded-lg px-10 py-2  font-bold text-lg border border-[#3a5dd1]  "
                          htmlFor=""
                        >
                          {"{{Current Date}}"}
                        </Label>
                      </div>
                    </div>

                    <div className="flex w-full gap-2">
                      <div className="gap-2  w-[100%]  border-[#3a5dd1] flex items-center justify-center">
                        <Label
                          className="text-center text-[#0D215C] w-[100%] rounded-lg px-10 py-2  font-bold text-lg border border-[#3a5dd1]  "
                          htmlFor=""
                        >
                          {"{{Scheme Name}}"}
                        </Label>
                      </div>
                    </div>

                    <div className="flex w-full gap-2">
                      <div className="gap-2  w-[100%]  border-[#3a5dd1] flex items-center justify-center">
                        <Label
                          className="text-center text-[#0D215C] w-[100%] rounded-lg px-10 py-2  font-bold text-lg border border-[#3a5dd1]  "
                          htmlFor=""
                        >
                          {"{{Class Name}}"}
                        </Label>
                      </div>
                    </div>
                    <div className="flex w-full gap-2">
                      <div className="gap-2  w-[100%]  border-[#3a5dd1] flex items-center justify-center">
                        <Label
                          className="text-center text-[#0D215C] w-[100%] rounded-lg px-10 py-2  font-bold text-lg border border-[#3a5dd1]  "
                          htmlFor=""
                        >
                          {"{{email}}"}
                        </Label>
                      </div>
                    </div>
                    <div className="flex w-full gap-2">
                      <div className="gap-2  w-[100%]  border-[#3a5dd1] flex items-center justify-center">
                        <Label
                          className="text-center text-[#0D215C] w-[100%] rounded-lg px-10 py-2  font-bold text-lg border border-[#3a5dd1]  "
                          htmlFor=""
                        >
                          {"{{password}}"}
                        </Label>
                      </div>
                    </div>
                  </div>
      
                  {/* 
<Button type="submit" className="md:w-[40%]  bg-[#0D215C] md:self-end w-full flex gap-3 " >
<IoMdAdd size={20} />
                      Add Variables
                    </Button> */}
                </div>
              </div>
            </div>
            <EmailEditorForEmailTemplate ref={emailEditorRef} JSONDesign={emailTemplateInfo && JSON.parse(emailTemplateInfo.json_design)} handleSetEmailTemplateBody={handleSetEmailTemplateBody} />
            <div className="w-full flex  p-6  bg-[#FFFFFF] rounded-md mt-2 justify-end">
              <Button
                type="submit"
                className="md:w-[40%]  bg-[#0D215C] md:self-end w-full "
              >
               {actionType && actionType==="Edit" ? "Save Changes": "Add Email Template"}
              </Button>
            </div>
           
          </form>
        )}
      />
    </>
  );
};

export default AddEmailTemplate;
